import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import type { ICounselorCallCta } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createCounselorCallCta(payload: Partial<ICounselorCallCta>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.COUNSELOR_CALL_CTA.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateCounselorCallCta(
  id: number,
  payload: Partial<ICounselorCallCta>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.COUNSELOR_CALL_CTA.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
